export const Path = ["name", "description", "type", "is_active"]

export const Heading = (t) => [
    { title: t("Name"), field: "name" },
    { title: t("Description"), field: "description" },
    { title: t("Type"), field: "type" },
    { title: t("Status"), field: "is_active", },
    { title: "", field: "icon" },
]

export const Type = [
    { type: ["text"], name: "name" },
    { type: ["text"], name: "description" },
    { type: ["text"], name: "type" },
    { type: ["status"], name: "is_active" },
    { type: ["more"], icon: "icon" },
]

export const defaultAddState = {
    formType: "add",
    id: "",
    name: "",
    description: "",
    type: "",
    is_active: true,
    is_delete: false,
    error: {
        name: "",
        type: "",
    }
}

export const defaultFilterData = { is_active: [true] }